// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","778":"component---src-templates-wedding-cards-tsx"}[chunkId] + "-" + {"245":"e6785c1544f8a662663a","453":"e8c71ad576008ab79379","778":"d4e8abf5d3891e96967e"}[chunkId] + ".js";
};